<template>
  <div class="wrap orderFail">
    <div class="header">
      <NavBar
        title="Payment failed"
        left-arrow
        @click-left="$router.push('/productList?'+ getStore('shareHttp'))"
        class="no_bg"
      >
      </NavBar>
    </div>
    <div class="main">
      <div class="Box">
        <div class="imgBox">
          <img src="../../../public/img/orderFail.png" alt="" />
        </div>
        <div class="text" >Payment Failed，please try again later</div>
        <Button
          color="#16C7CE"
          plain
          type="primary"
          block
          @click="$router.push('/productList?'+ getStore('shareHttp'))"
          >Back</Button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { removeStore, getStore, setStore } from "../../utils/storage";
export default {
  data() {
    return {
      
    }
  },
  methods:{
    getStore
  }
}
</script>
<style lang="less" scoped>
.orderFail {
  .Box {
    text-align: center;
    padding: 0 10px;
    background: #fff;
    .text {
      color: #090a0e;
      font-size: 15px;
      margin: 32px 0;
    }
    .imgBox {
      margin-top: 30px;
      img {
        width: 78px;
        height: 78px;
      }
    }
  }
}
</style>
<style>
.orderFail .van-button--primary {
  border: 0.028571rem solid #16c7ce;
  font-size: 15px;
}
</style>
